import { OnInit, Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Grade, Shape99InfoLine } from 'src/app/classes/json-interface';
import { CUtilit } from 'src/app/classes/utilit';
import { ArmaShapeComponent } from '../../arma-shape/arma-shape.component';
import { g_params } from 'src/app/classes/global-param';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { CLineDec, GradeManager } from 'src/app/classes/decorticage/info-decorticage';
import {ArmaServServerMethods} from '../../../classes/ArmaServServerMethods';

interface ModalData {
  LineDec: CLineDec;
  ArrayGrade: Grade[];
}

@Component({
  templateUrl: './dialogShape99.html',
  styleUrls: ['./dialogShape99.css']
})
// tslint:disable-next-line:component-class-suffix
export class DialogShape99 implements OnInit {

  /*
  Gestion de la ligne 99 sur angular
  dans armaor c'est sauvegarder dans la table LIGNE99 avec comme cote angle -> longueur -> angle
  la cote n1 correspont a l'angle de départ puis on fait une suite de longueur angle
  TODO: Etre capable d'enregistrer aussi les arc de cercle dans la forme 99
  */
  public static async openDialog(matDialog: MatDialog, lineDec: CLineDec, arrayGrade: Grade[]): Promise<CLineDec|false> {
    const modalData: ModalData = {
      LineDec: lineDec,
      ArrayGrade: arrayGrade
    };
    const dialogParamRef = matDialog.open(DialogShape99, {
      width: '75%',
      disableClose: true,
      data: modalData
    });
    return dialogParamRef.afterClosed().toPromise();
  }

  @ViewChild('canvasShape', {static: true}) mCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('armaShape99', {static: true}) mArmaShape!: ArmaShapeComponent;
  @ViewChild('contentRightSide', {static: true}) mDivContentRightSide!: ElementRef<HTMLDivElement>;
  @ViewChild('imgShape99', {static: true}) mImgShape99!: ElementRef<HTMLImageElement>;

  public get diameter(): string { return this.mCpyLineDec.mDiamNum; }
  public set diameter(diameter: string) { this.mCpyLineDec.mDiamNum = diameter; }

  public get grade(): string { return this.mCpyLineDec.mDiamGrade; }
  public set grade(grade: string) { this.mCpyLineDec.mDiamGrade = grade; }

  public get infoShape99(): Shape99InfoLine[] { return this.mCpyLineDec.mInfoShape99; }
  public set infoShape99(infoShape99: Shape99InfoLine[]) { this.mCpyLineDec.mInfoShape99 = infoShape99; }

  public mCanvasHeight: number = 0;
  public mCanvasWidth: number = 0;

  public mListErreurShape99: string[] = [];

  public mUrlImageShape99?: SafeUrl;

  private mCpyLineDec: CLineDec;   // Copie de la ligne en cours

  public HTML_ShowRealShape: boolean;

  private readonly mArrayGrade: Grade[];

  constructor(
    public mDialogRef: MatDialogRef<DialogShape99>,
    @Inject(MAT_DIALOG_DATA) modalData: ModalData,
    private mArmaServMethods: ArmaServServerMethods
  ) {
    // On fait une copie de la ligne en cours
    this.mCpyLineDec = new CLineDec();
    this.mCpyLineDec.update(modalData.LineDec);

    this.mArrayGrade = modalData.ArrayGrade;

    // On attribut le code forme 99
    this.mCpyLineDec.mCodeF = g_params.shapeCode99;

    if (!this.mCpyLineDec.mInfoShape99 || this.mCpyLineDec.mInfoShape99.length == 0) {
        this.initNewShape99OnLine();
    } else if (this.mCpyLineDec.mInfoShape99.length == 1) {
        this.addLineLenghtAngle();
    }
    // On ajoute quand même une ligne vide apres la deniere ligne en cours
    this.addLineLenghtAngle();

    this.HTML_ShowRealShape = CUtilit.loadOrInitUserParam().ImageType == 'Full';
  }

  ngOnInit(): void {
    // Init de la taille du canvas
    this.mCanvasHeight = this.mDivContentRightSide.nativeElement.scrollHeight;
    this.mCanvasWidth = this.mDivContentRightSide.nativeElement.offsetWidth;

    setTimeout(() => this.getDrawingShape99FromServer());
  }

  private initNewShape99OnLine() {
    if (!this.infoShape99)
      this.infoShape99 = [];
    this.infoShape99.length = 0;
    this.addLineLenghtAngle(); // Une ligne pour l'angle de départ
    this.addLineLenghtAngle(); // Une ligne pour le premier longueur angle
  }

  private addLineLenghtAngle(lenght: string = '', angle: string = '') {
    this.infoShape99.push({Radius: '', Length: lenght, Angle: angle});
  }

  onEnter(event: KeyboardEvent) {
    const htmlElem = (event.target as HTMLElement);
    const arrayInput = CUtilit.findInputsInHtmlElement(document.getElementById('div-shape99-leftSide'));
    for (let i = 0 ; i < arrayInput.length ; i++) {
      if (arrayInput[i].id == htmlElem.id) {
        if (i + 1 < arrayInput.length)
          arrayInput[i + 1].focus();
        break;
      }
    }
  }

  onDiameterChange() {
    if (!this.diameter)
      return;

    const checkGradeResult = GradeManager.getGradeFromDiam(+this.diameter, this.mArrayGrade);
    setTimeout(() => {
      if (checkGradeResult.found) {
        this.grade = checkGradeResult.gradeCode;
      } else {
        this.diameter = '';
        this.grade = '';
      }
      this.checkErreurShape99();
      this.getDrawingShape99FromServer();
    });
  }

  onBeginningAngleFocusOut() {
    setTimeout(() => {
      if (!this.infoShape99[0].Angle) {
        this.infoShape99[0].Angle = '0';
      }
      this.checkErreurShape99();
      this.getDrawingShape99FromServer();
    });
  }

  /**
   * Supprime tout ce qui n'est pas un nombre
   * @param event Input
   */
  checkInputLenghtAngle(event: HTMLInputElement, LengthAngle: 'Length'|'Angle', index: number) {
    //console.log('event.value', event.value);
    //console.log('mArrayLengthAngle[index][LengthAngle]', this.mArrayLengthAngle[index][LengthAngle]);
    if (isNaN(+event.value)) {
      event.value = '';
      this.infoShape99[index][LengthAngle] = '';
    }
  }

  onInputLenghtAngleFocus(id: number) {
    if (id == this.infoShape99.length - 1)
      this.addLineLenghtAngle();
    this.checkErreurShape99();
  }

  onDialogBtnClick(result: 'OK'|'CANCEL'|'CLEAR'|'DRAWING') {
    switch (result) {
      case 'OK':
        // On retournbe la copie de la ligne en resultat
        this.mDialogRef.close(this.mCpyLineDec);
        break;
      case 'CLEAR':
        this.initNewShape99OnLine();
        this.addLineLenghtAngle();
        CUtilit.findInputsInHtmlElement(document.getElementById('div-shape99-leftSide'))[0].focus();
        this.getDrawingShape99FromServer();
        break;
      case 'CANCEL':
      default:
        this.mDialogRef.close(false);
        break;
    }
  }

  /**
   * L'object 99 n'est pas valide quand :
   * - Le diametre n'est pas saisie
   * - La longueur de l'inferce
   * - L'angle de départ
   * - La premiere longueure
   */
  public checkErreurShape99() {

    function isValideStrNumber(value: string, checkSupZero: boolean): boolean {
      let valide = (value !== undefined) && (value != null) && (value !== '') && (!isNaN(+value));
      if (valide && checkSupZero)
        valide = +value > 0;
      return valide;
    }

    // Re init des erreurs
    this.mListErreurShape99.length = 0;

    // Check diameter
    if (+this.diameter == 0 || isNaN(+this.diameter))
      this.mListErreurShape99.push('Diameter not set');

    // Check longueur de l'interface
    if (this.infoShape99.length >= 2) {
      // Check angle de départ valide
      if (!isValideStrNumber(this.infoShape99[0].Angle, false))
        this.mListErreurShape99.push('Begining angle is incorect');

      // Check de la saisie de la premiere longueure
      if (!isValideStrNumber(this.infoShape99[1].Length, true))
        this.mListErreurShape99.push('First measure is not correct');

    } else this.mListErreurShape99.push('Internal error'); // Ne devrais pas se produire
  }

  public async getDrawingShape99FromServer() {
    this.checkErreurShape99();
    if (this.mListErreurShape99.length == 0 && this.HTML_ShowRealShape) {
      this.mUrlImageShape99 = await this.mArmaServMethods.getDrawingShape(this.mCpyLineDec, this.mCanvasWidth, this.mCanvasHeight);
    } else {
      this.mUrlImageShape99 = undefined;
    }
  }
}
